import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getRandomId } from '../rtsp-player/libs/utils';
import * as _ from 'lodash';
import PlayerSEI from './player-sei';
import { QueueModule } from '@blade-sxp/monitor/store/queue';
const H5SensePlayer = require('./lib/h5_sense_player.js').default;
let RtspPlayer = class RtspPlayer extends Vue {
    videoWsHost;
    videoUrl;
    autoPlay;
    drawRect;
    renderType;
    showAttrsInfo;
    videoUrlTransform = '';
    videoWsHostTransform = '';
    loading = false;
    videoPlayerId = getRandomId();
    player;
    playerSEI;
    timeupdateInterval;
    playerContainer;
    overlayCanvas;
    animatedframe;
    isPlayerFirst = true;
    config;
    options;
    taskRoi;
    isPlayerSEI = false;
    whenNeedToDrawRect(val) {
        if (this.playerSEI) {
            this.playerSEI.setShowRect(val);
        }
    }
    onShowAttrsInfoChange(val) {
        if (this.playerSEI) {
            this.playerSEI.setShowAttrInfo(val);
        }
    }
    onEventConfigChange(val) {
        if (this.playerSEI) {
            this.playerSEI.setEventConfig(val);
        }
    }
    get taskId() {
        return QueueModule.taskId;
    }
    get deviceId() {
        return QueueModule.deviceId;
    }
    handleResize() {
        // console.log('resize');
        if (this.playerSEI) {
            console.log('resize');
            this.playerSEI.updateCanvas();
        }
    }
    initialVideoPlayer() {
        this.timeupdateInterval = _.debounce(this.refreshVideoPlayer, 10000);
        this.timeupdateInterval?.();
        this.loading = true;
        if (this.player) {
            this.player.stop();
        }
        this.player = new H5SensePlayer(this.getoptions());
        this.player.play();
        this.player.on('error', (err) => {
            console.log('error:', err);
        });
        this.player.on('canplay', () => {
            this.initPlayerSEI(); // not render on parent to meet dynamic needs
            console.log('canplay');
        });
        this.player.on('play', () => {
            this.loading = false;
            console.log('play');
        });
        this.player.on('waiting', () => {
            console.log('waiting');
        });
        this.player.on('mediaInfo', (info) => {
            console.log('mediaInfo:', info);
        });
        this.player.on('timeupdate', () => {
            // console.log('timeupdate');
            this.timeupdateInterval?.();
        });
    }
    // 拖动播放进度条
    changeVideoProgress(val) {
        const refVideo = this.$refs.video;
        refVideo.currentTime = val;
    }
    refreshVideoPlayer() {
        if (this.player) {
            this.destroyVideoPlayer();
        }
        this.initialVideoPlayer();
    }
    destroyVideoPlayer() {
        console.log('destroy');
        this.playerSEI && this.playerSEI.clear();
        this.player && this.player?.stop();
        this.player = null;
        this.timeupdateInterval?.cancel();
        this.timeupdateInterval = null;
        this.isPlayerSEI = false;
    }
    stop() {
        this.destroyVideoPlayer();
    }
    transformVideoConfig() {
        const { search, protocol, pathname } = new URL(this.videoUrl);
        this.videoUrlTransform = protocol + pathname;
        this.videoWsHostTransform = this.videoWsHost + search;
        console.log('videoUrlTransform:', this.videoUrlTransform);
    }
    changeVideoSize() {
        // this.$nextTick(() => {
        if (this.playerSEI) {
            this.playerSEI.updateCanvas();
        }
        // });
    }
    created() {
        this.transformVideoConfig();
    }
    mounted() {
        this.playerContainer = document.getElementById('videoContainer');
        this.overlayCanvas = document.getElementById('canvas');
        // this.initOverlay();
        this.initialVideoPlayer();
        // this.initPlayerSEI();
        if (this.isPlayerFirst) {
            this.isPlayerFirst = false;
        }
    }
    async getData() {
        console.log('taskid');
        try {
            const res = await QueueModule.getTaskByDeviceId({ taskId: this.taskId, deviceId: this.deviceId });
            console.log('res:', res);
            this.taskRoi = this.mapRoi(res.data?.baseTaskVOS);
            console.log('id:', this.taskRoi);
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    mapRoi(item) {
        const res = item.map((item) => {
            if (item.taskType === 2) {
                return { taskType: item.taskType, frontEndData: item.frontEndData };
            }
            if (item.taskType === 10) {
                return { taskType: item.taskType, configJson: item.configJson };
            }
        });
        return res;
    }
    async initPlayerSEI() {
        const childNodes = this.playerContainer.getElementsByTagName('video')[0];
        if (this.player && !this.isPlayerSEI) {
            this.isPlayerSEI = true;
            await this.getData();
            this.playerSEI = new PlayerSEI(this.player, childNodes, { renderType: this.renderType, roi: this.taskRoi });
        }
    }
    getoptions() {
        console.log('player container:', this.playerContainer);
        const res = {
            url: this.videoUrlTransform,
            socketurl: this.videoWsHostTransform,
            preferMode: 'mse',
            container: this.playerContainer,
            wasmDebugMode: 1,
        };
        return res;
    }
    beforeDestroy() {
        this.destroyVideoPlayer();
    }
};
__decorate([
    Prop({ default: '', validator: (value) => !!value.match(/^(wss?):/i) })
], RtspPlayer.prototype, "videoWsHost", void 0);
__decorate([
    Prop({ default: '', validator: (value) => !!value.match(/^(rtsp):/i) })
], RtspPlayer.prototype, "videoUrl", void 0);
__decorate([
    Prop({ default: false })
], RtspPlayer.prototype, "autoPlay", void 0);
__decorate([
    Prop({ default: false })
], RtspPlayer.prototype, "drawRect", void 0);
__decorate([
    Prop({ default: 'frame' })
], RtspPlayer.prototype, "renderType", void 0);
__decorate([
    Prop({ default: false })
], RtspPlayer.prototype, "showAttrsInfo", void 0);
__decorate([
    Watch('drawRect')
], RtspPlayer.prototype, "whenNeedToDrawRect", null);
__decorate([
    Watch('showAttrsInfo')
], RtspPlayer.prototype, "onShowAttrsInfoChange", null);
__decorate([
    Watch('eventConfig', { deep: true })
], RtspPlayer.prototype, "onEventConfigChange", null);
RtspPlayer = __decorate([
    Component({
        name: 'RtspSense',
    })
], RtspPlayer);
export default RtspPlayer;
